import { SocketDisconnect } from '~/data/repository/socket/waitingRoom';
import { makeSocket } from '~/main/factories/socket';
import { Disconnect as UseCaseSocketDisconnect } from '~/domain/usecases/waitingRoom/socket';

/**
 * Join at conference by SocketIO.
 */
export const makeSocketDisconnect = (): UseCaseSocketDisconnect =>
  new SocketDisconnect('SocketDisconnect', makeSocket());
